import { render, staticRenderFns } from "./c_recommend.vue?vue&type=template&id=5937c0f7&scoped=true"
import script from "./c_recommend.vue?vue&type=script&lang=js"
export * from "./c_recommend.vue?vue&type=script&lang=js"
import style0 from "./c_recommend.vue?vue&type=style&index=0&id=5937c0f7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5937c0f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5937c0f7')) {
      api.createRecord('5937c0f7', component.options)
    } else {
      api.reload('5937c0f7', component.options)
    }
    module.hot.accept("./c_recommend.vue?vue&type=template&id=5937c0f7&scoped=true", function () {
      api.rerender('5937c0f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_recommend.vue"
export default component.exports